import type {
  StorageLocationWriteData,
  StorageLocationDetailsResponse,
} from 'src/apis/storage/types';
import { useAxios } from 'src/hooks/use-axios';
import { isConstraintViolation } from 'src/utils/is-constraint-violation';

type RequestOptions = {
  url: string;
  data: StorageLocationWriteData;
};

export function useStorageLocationEdit() {
  return useAxios(
    (axios, baseConfig, { url, data }: RequestOptions) =>
      axios.request<StorageLocationDetailsResponse>({
        ...baseConfig,
        method: 'PUT',
        url,
        data,
      }),
    {
      neededOnPageLoad: false,
      onError(error) {
        if (isConstraintViolation(error)) {
          return error;
        }
        throw error;
      },
    }
  );
}

export type StorageLocationEditRequest = ReturnType<
  typeof useStorageLocationEdit
>;
